export type Questions = {
  [n: number]: Choice[]
}

export type Choice = {
  value: string
  hasDescription?: boolean
  eliminatedBy?: string[][]
}

export const questions: Questions = {
  1: [
    { value: 'coffee-black' },
    { value: 'coffee-with-milk' },
    { value: 'coffee-with-milk-and-sugar' },
    { value: 'coffee-decaf' },
  ],
  2: [
    { value: 'method-chemex' },
    { value: 'method-pour-over' },
    { value: 'method-french-press' },
    { value: 'method-aeropress' },
    { value: 'method-espresso-maker' },
    { value: 'method-espresso-machine' },
    { value: 'method-filter-coffee-machine' },
    { value: 'method-full-automatic-machine' },
  ],
  3: [
    {
      value: 'taste-classic',
      hasDescription: true,
      eliminatedBy: [
        ['coffee-with-milk-and-sugar', 'method-chemex'],
        ['coffee-with-milk-and-sugar', 'method-pour-over'],
        ['coffee-with-milk-and-sugar', 'method-french-press'],
        ['coffee-with-milk-and-sugar', 'method-aeropress'],
        ['coffee-with-milk-and-sugar', 'method-espresso-maker'],
        ['coffee-with-milk-and-sugar', 'method-espresso-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-full-automatic-machine'],
        ['coffee-with-milk', 'method-full-automatic-machine'],
        ['coffee-black', 'method-full-automatic-machine'],
        ['coffee-decaf', 'method-chemex'],
        ['coffee-decaf', 'method-pour-over'],
        ['coffee-decaf', 'method-french-press'],
        ['coffee-decaf', 'method-aeropress'],
        ['coffee-decaf', 'method-espresso-maker'],
        ['coffee-decaf', 'method-espresso-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-full-automatic-machine'],
      ],
    },
    {
      value: 'taste-curious',
      hasDescription: true,
      eliminatedBy: [
        ['coffee-with-milk-and-sugar', 'method-chemex'],
        ['coffee-with-milk-and-sugar', 'method-pour-over'],
        ['coffee-with-milk-and-sugar', 'method-french-press'],
        ['coffee-with-milk-and-sugar', 'method-aeropress'],
        ['coffee-with-milk-and-sugar', 'method-espresso-maker'],
        ['coffee-with-milk-and-sugar', 'method-espresso-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-full-automatic-machine'],
        ['coffee-with-milk', 'method-full-automatic-machine'],
        ['coffee-black', 'method-full-automatic-machine'],
        ['coffee-decaf', 'method-chemex'],
        ['coffee-decaf', 'method-pour-over'],
        ['coffee-decaf', 'method-french-press'],
        ['coffee-decaf', 'method-aeropress'],
        ['coffee-decaf', 'method-espresso-maker'],
        ['coffee-decaf', 'method-espresso-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-full-automatic-machine'],
      ],
    },
    {
      value: 'taste-adventurous',
      hasDescription: true,
      eliminatedBy: [
        ['coffee-with-milk-and-sugar', 'method-chemex'],
        ['coffee-with-milk-and-sugar', 'method-pour-over'],
        ['coffee-with-milk-and-sugar', 'method-french-press'],
        ['coffee-with-milk-and-sugar', 'method-aeropress'],
        ['coffee-with-milk-and-sugar', 'method-espresso-maker'],
        ['coffee-with-milk-and-sugar', 'method-espresso-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-filter-coffee-machine'],
        ['coffee-with-milk-and-sugar', 'method-full-automatic-machine'],
        ['coffee-with-milk', 'method-chemex'],
        ['coffee-with-milk', 'method-pour-over'],
        ['coffee-with-milk', 'method-french-press'],
        ['coffee-with-milk', 'method-aeropress'],
        ['coffee-with-milk', 'method-espresso-maker'],
        ['coffee-with-milk', 'method-espresso-machine'],
        ['coffee-with-milk', 'method-filter-coffee-machine'],
        ['coffee-with-milk', 'method-filter-coffee-machine'],
        ['coffee-with-milk', 'method-full-automatic-machine'],
        ['coffee-black', 'method-full-automatic-machine'],
        ['coffee-decaf', 'method-chemex'],
        ['coffee-decaf', 'method-pour-over'],
        ['coffee-decaf', 'method-french-press'],
        ['coffee-decaf', 'method-aeropress'],
        ['coffee-decaf', 'method-espresso-maker'],
        ['coffee-decaf', 'method-espresso-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-filter-coffee-machine'],
        ['coffee-decaf', 'method-full-automatic-machine'],
      ],
    },
  ],
}
